import React, { useEffect, useState } from "react";
import ReactPixel from 'react-facebook-pixel';
import { useParams, useHistory } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import "bootstrap/dist/css/bootstrap.min.css";

import ReactPlayer from 'react-player'
import gplay from "../../assets/home/gplay.png";
import testi1 from "../../assets/home/testi1.png";
import testi2 from "../../assets/home/testi2.png";
import testi3 from "../../assets/home/testi3.png";
import whyclapingo from "../../assets/home/whyclapingo.png";
import top from "../../assets/home/top.png";
import bottom from "../../assets/home/bottom.png";
import tick from "../../assets/home/tick.png";
import fadelogo from "../../assets/home/fadelogo.png";
import ornament from "../../assets/home/ornament.png";
import AuthModal from "../../components/AuthModals/AuthModal";
import { createjscssfile, initPixel } from "../../helpers/CampaignEvents";

const user = JSON.parse(localStorage.getItem("USER"));

// function useQuery() {
//   return new URLSearchParams(useLocation().search);
// }

const FbHomePageRedesign = () => {

    let { id } = useParams();
    useEffect(() => {
        initPixel()
        createjscssfile()
        if (id) {
            var decodedString = window.atob(id);
            localStorage.setItem("INFLUENCER_CODE", decodedString)
        }
    }, [])

    const [openModal, setOpenModal] = useState(false);
    const history = useHistory();
    useEffect(() => {
        if (user) {
            history.push("/dashboard");
        }
    }, [user]);

    useEffect(() => {
        AOS.init();
    });

    const showModal = () => setOpenModal(true);
    const closeModal = () => setOpenModal(false);
    return (
        <>
            <AuthModal />
            <div className="auth_model_wrapper">
                <AuthModal openModal={openModal} closeModal={closeModal} />
            </div>
            <div style={{ backgroundColor: "#ffffff" }}>
                {/* HEADER SECTION STARTS */}
                <div className="header_section" style={{ overflowX: "hidden" }}>
                    <div className="d-flex align-items-center ">
                        <div className="container mt-0 mt-md-3">
                            <div className="row pt-2 mt-3">
                                <div className="col-md-7 order-2 order-md-1 order-lg-1 d-flex flex-column justify-content-center">
                                    <div className="circle blue">
                                    </div>
                                    <h1 className="header_text">
                                        Live, <span className="one">one-on-one</span> online classes for English .{" "}<br />
                                        {/* <span className="one">one-on-one</span> video call */}
                                    </h1>

                                    {/* <h4 className=" text-white " style={{fontWeight:"bold"}}>Exclusive Offer Download the Android App and book your trial at just   ₹1/-</h4> */}
                                    <div className="mt-md-2 ">
                                        <p className="sub_header_text">
                                            Practice english conversation with excellent
                                            communicators <br />across the country and speak
                                            like a <span style={{ fontWeight: "bold", color: "black" }}>PRO</span>
                                        </p>
                                    </div>
                                    <div className="pt-md-2 mt-1 home_button_container">
                                        <button
                                            className="bookBTN1"
                                            id="button1"
                                            onClick={() => {
                                                ReactPixel.track('AddToCart', { "value": "99.00","currency": 'INR'});
                                                history.push("/fb/book-demo/:component")
                                        }}
                                        >
                                            Book Your Trial @ ₹99
                                        </button>
                                    </div>
                                    
                                </div>

                                <div className="col-md-5 mobile order-1 mt-5">
                                    <div className="top-img">
                                        <img src={top} height="100%" width="140%" alt="clapingo header" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* <div className="mouse-container">
                        <div className="mouse">
                            <span className="scroll-down"></span>
                        </div>
                    </div> */}
                </div>
                {/* HEADER SECTION ENDSS */}

                {/* WHAT WE OFFER SECTION STARTS */}
                <div className="what_we_offer pt-2" style={{ overflowX: "hidden" }}>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6 ">
                                <p className="convo-text mt-5">Conversations are<br /> easily forgotten.<br />
                                    <span style={{ fontWeight: "bold" }}>
                                        Recall and share every<br /> detail with <span className="one">Clapingo.</span>
                                    </span>
                                </p>
                                <button
                                    onClick={() => {
                                        ReactPixel.track('AddToCart', { "value": "99.00","currency": 'INR'});
                                        history.push("/fb/book-demo/:component")
                                    }}
                                    id="button2"
                                    className="booktrial-BTN2">Book Your Trial</button>
                            </div>
                            <div className="col-md-6">
                                <div className="vid-div">
                                    {/* <Player className="player ml-md-4 " >
                                        <source src="https://youtu.be/iJKCj8uAHz8" />
                                    </Player> */}
                                    <ReactPlayer
                                        className='react-player'
                                        width='100%'
                                        height='100%'
                                        controls
                                        // light="true"
                                        url="https://youtu.be/EnFqoUEKoHE"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* WHAT WE OFFER SECTION ENDS */}


                {/* WHY CLAPINGO SECTIONS STARTS */}
                <div className="why_clapingo " style={{ overflowX: "hidden" }}>
                    <div >
                        <div className="row">
                            <div className="col-md-6">
                                <div className="fadelogo">
                                    <img src={fadelogo} alt="logo" />
                                </div>
                                <div className="margin-wrapper">
                                    <p className="title-why">Why <span className="one" style={{ fontWeight: "bold" }}>Clapingo</span> is your<br /> best option?</p>
                                    <div className="points mt-5">
                                        <div className="why_flex">
                                            <img src={tick} alt="tick" />
                                            <p className="why_subtitle">Practice Speaking Skills</p>
                                        </div>
                                        <div className="why_flex">
                                            <img src={tick} alt="tick" />
                                            <p className="why_subtitle">Recorded Sessions</p>
                                        </div>
                                        <div className="why_flex">
                                            <img src={tick} alt="tick" />
                                            <p className="why_subtitle">Friendly Environment</p>
                                        </div>
                                        <div className="why_flex">
                                            <img src={tick} alt="tick" />
                                            <p className="why_subtitle">Learn at your own pace</p>
                                        </div>
                                        <div className="why_flex">
                                            <img src={tick} alt="tick" />
                                            <p className="why_subtitle">Undivided Attention</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="ornament">
                                    <img src={ornament} alt="logo" />
                                </div>
                                <div className="ornament2">
                                    <img src={ornament} alt="logo" />
                                </div>
                                <div className="ml-3 mt-5 why-img">
                                    <img src={whyclapingo} width="500px" height="400px" alt="why clapingo" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* WHY CLAPINGO SECTIONS ENDS */}

                {/* CLAPINGO TEACHERS SECTION STARTS */}
                <div className="learners" style={{ overflowX: "hidden" }}>
                    <div className="container">
                        <div className="container">
                            <div className="text-center ">
                                <button
                                    onClick={() => {
                                        ReactPixel.track('AddToCart', { "value": "99.00","currency": 'INR'});
                                        history.push("/fb/book-demo/:component")
                                    }}
                                    id="button3"
                                    className="booktrial-BTN3">Book your Trial</button>
                                <p className="learner-title mt-4 mb-3">Just don't take our word for it.<br />Look what our <span className="one">Learners</span> have to say.</p>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="testimonial-flex">
                                            <div>
                                                <img src={testi1} alt="testimonial" />
                                            </div>
                                            <div className="ml-4 mr-4">
                                            <img src={testi3} alt="testimonial" />
                                            </div>
                                            <div>
                                            <img src={testi2} alt="testimonial" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
                {/* CLAPINGO TEACHER SECTION ENDS */}
                {/* BOTTOM SECTION STARTS */}
                <div className="bottom_section" style={{ overflowX: "hidden" }}>
                    <div className="d-flex align-items-center ">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-6">
                                    <p className="bottom-title mt-5">Download our <span className="one" style={{ fontWeight: "bold" }}>App</span> now!</p>
                                    <div className="row mt-5 ml-1">
                                        <div className="d-inline">
                                            <div className="d-flex">
                                                <div className="line">
                                                </div>
                                                <div>
                                                    <h6 className="numbers">50k<span className="one" style={{ color: "#24A791", fontWeight: "bold" }}>+</span> </h6>
                                                    <h6 className="number-subtitle">Mobile Downloads</h6>
                                                </div>
                                            </div>

                                        </div>
                                        <div className="d-inline inline-marginA">
                                            <div className="d-flex">
                                                <div className="line">
                                                </div>
                                                <div>
                                                    <h6 className="numbers">80k<span className="one" style={{ color: "#24A791", fontWeight: "bold" }}>+</span> </h6>
                                                    <h6 className="number-subtitle">Happy Learners</h6>
                                                </div>
                                            </div>

                                        </div>


                                    </div>
                                    <div className="row mt-3 ml-1">
                                        <div className="d-inline">
                                            <div className="d-flex">
                                                <div className="line">
                                                </div>
                                                <div>
                                                    <h6 className="numbers">53k<span className="one" style={{ color: "#24A791", fontWeight: "bold" }}>+</span> </h6>
                                                    <h6 className="number-subtitle">Sessions<br /> per month</h6>
                                                </div>
                                            </div>

                                        </div>
                                        <div className="d-inline inline-marginB">
                                            <div className="d-flex">
                                                <div className="line">
                                                </div>
                                                <div>
                                                    <h6 className="numbers">200<span className="one" style={{ color: "#24A791", fontWeight: "bold" }}>+</span> </h6>
                                                    <h6 className="number-subtitle">Speakers around<br /> the country</h6>
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                    <div className="mt-3">
                                        <span className="mr-2">
                                            <a target="_blank" href="https://play.google.com/store/apps/details?id=com.app.clapingo&hl=en_IN&gl=US">
                                                <img
                                                    src={gplay} alt="google play logo" />
                                            </a>
                                        </span>
                                        {/* <span className="ml-2">
                                                <img src={appstore} alt="appstore logo" />
                                            </span> */}
                                    </div>

                                </div>
                                <div className="col-md-6">
                                    <div className="bottom-img">
                                        <img src={bottom} alt="bottom" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* BOTTOM SECTION ENDS */}
            </div>
        </>
    );
};

export default FbHomePageRedesign;